import React from "react";
import moment from "moment";
import { axiosCommon } from "../../../util/axiosSetup.js";
import { BASE_URL } from "../../../util/Urls";
import formatDate from "../../../util/formatDate";
import StyledDateRangePicker from "../../../components/StyledDateRangePicker";
import NavHeader from "../../../components/NavHeader";
import Footer from "../../../components/Footer";
import {
    Button,
    Checkbox,
    FormControlLabel,
    IconButton,
    MenuItem,
    TextField,
    Toolbar,
    Typography
} from "@material-ui/core";
import { TimePicker } from '@material-ui/pickers';
import ClearIcon from "@material-ui/icons/Clear";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Widget from "../../../components/Widget";
import Card from "../../../components/Card";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SaveCancelButtons from "../../../components/SaveCancelButtons";
import DiscountType from "../../../enums/DiscountType";
import DiscountApplyType from "../../../enums/DiscountApplyType";
import DiscountMethod from "../../../enums/DiscountMethod";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import DayOfWeek from "../../../enums/DayOfWeek";
import axios from "axios";

const FULL_DAY = { start: "00:00:00", end: "23:59:59" };
const DISABLED_DAY = { start: "00:00:00", end: "00:00:00" };
const START_OF_DAY = "00:00:00";
const END_OF_DAY = "23:59:59";

// A backend ISO_LOCAL_TIME formátumban szerializálja a LocalTime értékeket, ami elhagyja
// a másodperceket, ha azok nullák ("00:00:00" helyett "00:00" jön vissza). Minden
// összehasonlítás előtt egységes HH:mm:ss alakra hozzuk az időpontokat.
const normalizeTime = (time) => {
    if (!time) return time;
    const parts = time.split(":");
    while (parts.length < 3) parts.push("00");
    return parts.map(part => part.padStart(2, "0")).join(":");
}

const timeToSeconds = (time) => {
    const [hours, minutes, seconds] = normalizeTime(time).split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
}

const formatTime = (date) =>
    `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:00`;

const normalizeValidTimes = (validTimes) => Object.fromEntries(
    Object.entries(validTimes).map(([day, { start, end }]) =>
        [day, { start: normalizeTime(start), end: normalizeTime(end) }])
);

export default class EditDiscount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customerOptions: [{label: "Összes", value: -1}],
            selectedCustomers: [{label: "Összes", value: -1}],
            subjectTypeOptions: [{label: "Összes", value: -1}],
            selectedSubjectType: [{label: "Összes", value: -1}],
            allOption: { label: "Összes", value: -1 },
            selectedDiscountType: this.discountTypeOptions()[0],
            selectedDiscountApplyType: this.discountApplyTypeOptions()[0],
            selectedDiscountMethod: this.discountMethodOptions()[0],
            shopOptions: [],
            selectedShopOption: null,
            continuous: true,
            dayValidityBackup: {},
            discount: {
                name: null,
                description: null,
                shopId: null,
                enabled: true,
                fromDateTime: null,
                toDateTime: null,
                value: null,
                discountType: DiscountType.PRODUCT,
                discountApplyType: DiscountApplyType.AUTOMATIC,
                discountMethod: DiscountMethod.PERCENTAGE,
                barcode: null,
                products: [],
                appliesToAllProducts: true,
                categories: [],
                appliesToAllCategories: false,
                consumerTypes: [],
                appliesToAllConsumerTypes: false,
                validTimes: {
                    MONDAY: { ...FULL_DAY },
                    TUESDAY: { ...FULL_DAY },
                    WEDNESDAY: { ...FULL_DAY },
                    THURSDAY: { ...FULL_DAY },
                    FRIDAY: { ...FULL_DAY },
                    SATURDAY: { ...FULL_DAY },
                    SUNDAY: { ...FULL_DAY },
                },
            },
            isSubmitInProgress: false,
            isEdit: false,
        };
    }

    componentDidMount() {
        axios.all([
            axiosCommon.get(`${BASE_URL}/api/shops`),
            axiosCommon.get(`${BASE_URL}/api/consumercategories`)])
        .then((response) => {
            const shopOptions = response[0].data.items.map(c => {
                return {label: c.name, value: c.id}
            });
            shopOptions.unshift(this.state.allOption);

            const customerOptions = response[1].data.items.map(({ name, id }) => ({ label: name, value: id }));
            customerOptions.unshift(this.state.allOption)

            this.setState({
                shopOptions,
                selectedShopOption: shopOptions[0],
                customerOptions,
                selectedCustomers: [customerOptions[0]],
                isEdit: this.props.location.discountId !== undefined,
            }, () => {
                if (this.props.location.discountId) {
                    axiosCommon.get(`${BASE_URL}/api/discounts/${this.props.location.discountId}`)
                    .then(response => {
                        const selectedDiscountType = this.discountTypeOptions().find(o => o.value === response.data.discountType)
                        const selectedDiscountMethod = this.discountMethodOptions().find(o => o.value === response.data.discountMethod)
                        const selectedDiscountApplyType = this.discountApplyTypeOptions().find(o => o.value === response.data.discountApplyType)
                        const selectedShopOption = response.data.shop ? this.state.shopOptions.find(s => s.value === response.data.shop.id) : this.state.allOption
                        const continuous = response.data.fromDateTime === null && response.data.toDateTime === null
                        const discount = response.data

                        const dayOrder = Object.keys(DayOfWeek);
                        discount.validTimes = normalizeValidTimes(Object.fromEntries(
                            Object.entries(discount.validTimes)
                            .sort(([dayA], [dayB]) => dayOrder.indexOf(dayA) - dayOrder.indexOf(dayB))
                        ));

                        const selectedCustomers = [];
                        if (discount.appliesToAllConsumerTypes) {
                            selectedCustomers.unshift(this.state.allOption);
                        } else if(discount.consumerTypes.length > 0) {
                            discount.consumerTypes.forEach(ct => {
                                const option = this.state.customerOptions.find(o => o.value === ct.id);
                                if (option) selectedCustomers.push(option);
                            });
                        }

                        const newState = {
                            discount,
                            selectedShopOption,
                            selectedDiscountApplyType,
                            selectedDiscountMethod,
                            selectedCustomers,
                            continuous,
                            toDate: discount.toDateTime ? moment(discount.toDateTime).toDate() : null,
                            fromDate: discount.fromDateTime ? moment(discount.fromDateTime).toDate() : null
                        }
                        this.setState(newState, () => this.setDiscountType(null, selectedDiscountType))
                    })
                    .catch(error => this.setState({error}));
                } else {
                    this.setDiscountType(null, this.discountTypeOptions()[0])
                }
            })

        })
        .catch(error => this.setState({error}))
    }

    discountTypeOptions = () => {
        return [
            {label: "Termék", value: DiscountType.PRODUCT},
            {label: "Kategória", value: DiscountType.CATEGORY},
            {label: "Kosár", value: DiscountType.CONSUMER},
        ]
    }

    discountApplyTypeOptions = () => {
        return [
            {label: "Manuálisan kell kiválasztani", value: DiscountApplyType.MANUAL},
            {label: "Automatikusan felszámolódik", value: DiscountApplyType.AUTOMATIC},
            {label: "Vonalkód beolvasással adható", value: DiscountApplyType.CODE},
        ]
    }

    discountMethodOptions = () => {
        return [
            {label: "Százalék", value: DiscountMethod.PERCENTAGE},
            {label: "Árkülönbség", value: DiscountMethod.DIFFERENCE},
            {label: "Beszerzési ár", value: DiscountMethod.ACQUISITION_PRICE},
        ]
    }

    setDiscountType = (event, value) => {
        const subjectTypeOptions = [this.state.allOption]

        this.setState({selectedDiscountType: value, subjectTypeOptions, selectedSubjectType: subjectTypeOptions }, () => {
            switch (value.value) {
                case DiscountType.CATEGORY:
                    axiosCommon.get(`${BASE_URL}/api/categories?deleted=false`)
                        .then(response => {
                            const subjectTypeOptions = response.data.items.map(({ name, id }) => ({ label: name, value: id }));
                            subjectTypeOptions.unshift(this.state.allOption)

                            const selectedSubjectType = []
                            if(this.state?.discount?.appliesToAllCategories || !this.state?.discount?.categories.length){
                                selectedSubjectType.unshift(this.state.allOption)
                            } else {
                                this.state?.discount?.categories.forEach(ct => {
                                    const option = subjectTypeOptions.find(o => o.value === ct.id)
                                    if(option) selectedSubjectType.push(option)
                                })
                            }

                            this.setState({
                                subjectTypeOptions,
                                selectedSubjectType,
                            })
                        })
                        .catch(error => this.setState({error}))
                    break;
                case DiscountType.PRODUCT:
                    axiosCommon.get(`${BASE_URL}/api/products/basic?deleted=false`)
                        .then(response => {
                            const subjectTypeOptions = response.data.items.map(({ name, id }) => ({ label: name, value: id }));
                            subjectTypeOptions.unshift(this.state.allOption)

                            const selectedSubjectType = []
                            if(this.state?.discount?.appliesToAllProducts || !this.state?.discount?.products.length){
                                selectedSubjectType.unshift(this.state.allOption)
                            } else {
                                this.state?.discount?.products.forEach(ct => {
                                    const option = subjectTypeOptions.find(o => o.value === ct.id)
                                    if(option) selectedSubjectType.push(option)
                                })
                            }

                            this.setState({
                                subjectTypeOptions,
                                selectedSubjectType,
                            })
                        })
                        .catch(error => this.setState({error}))
                    break;
                default:
                    // Do nothing, consumer type was already loaded in componentDidMount
                    break;
            }
        })
    }

    isDayDisabled = (day) => {
        const validTime = this.state.discount.validTimes[day];
        return normalizeTime(validTime.start) === DISABLED_DAY.start
            && normalizeTime(validTime.end) === DISABLED_DAY.end;
    }

    setDayEnabled = (day, enabled) => {
        const { discount, dayValidityBackup } = this.state;

        if (enabled) {
            discount.validTimes[day] = { ...(dayValidityBackup[day] || FULL_DAY) };
        } else {
            if (!this.isDayDisabled(day)) dayValidityBackup[day] = { ...discount.validTimes[day] };
            discount.validTimes[day] = { ...DISABLED_DAY };
        }
        this.setState({ discount, dayValidityBackup });
    }

    resetDayValidity = (day) => {
        const { discount, dayValidityBackup } = this.state;
        delete dayValidityBackup[day];
        discount.validTimes[day] = { ...FULL_DAY };
        this.setState({ discount, dayValidityBackup });
    }

    updateDayValidity = (day, field, date) => {
        if (!date) return;
        const { discount } = this.state;
        const validTime = discount.validTimes[day];
        const newTime = formatTime(date);

        if (field === "start") {
            validTime.start = newTime;
            if (timeToSeconds(newTime) >= timeToSeconds(validTime.end)) validTime.end = END_OF_DAY;
        } else {
            const isEndOfDay = timeToSeconds(newTime) === 0 || newTime === "23:59:00";
            validTime.end = isEndOfDay ? END_OF_DAY : newTime;
            if (timeToSeconds(validTime.end) <= timeToSeconds(validTime.start)) validTime.start = START_OF_DAY;
        }
        this.setState({ discount });
    }

    onSubmit = () => {
        if (this.state.isSubmitInProgress || !this.state.selectedShopOption) return;

        const {discount} = this.state;

        discount.owner = undefined
        discount.shop = undefined
        discount.category = undefined
        discount.product = undefined

        discount.shopId = this.state.selectedShopOption.value === -1 ? undefined : this.state.selectedShopOption.value;

        if (this.state.continuous) {
            discount.fromDateTime = undefined;
            discount.toDateTime = undefined;
        } else {
            discount.fromDateTime = this.state.fromDate ? `${formatDate(this.state.fromDate)}T00:00:00.00` : undefined;
            discount.toDateTime = this.state.toDate ? `${formatDate(this.state.toDate)}T23:59:59.99` : undefined;
        }

        discount.discountType = this.state.selectedDiscountType.value;
        discount.discountApplyType = this.state.selectedDiscountApplyType.value
        discount.discountMethod = this.state.selectedDiscountMethod.value

        discount.products = []
        discount.categories = []
        discount.consumerTypes = []

        if (this.state.selectedCustomers.length === 1 && this.state.selectedCustomers[0].value === -1) {
            discount.appliesToAllConsumerTypes = true
        } else {
            discount.appliesToAllConsumerTypes = false
            this.state.selectedCustomers.forEach(st => {
                if(st.value !== -1) discount.consumerTypes.push(st.value)
            })
        }

        switch (discount.discountType) {
            case DiscountType.CATEGORY:
                discount.appliesToAllProducts = false

                if (this.state.selectedSubjectType.length === 1 && this.state.selectedSubjectType[0].value === -1) {
                    discount.appliesToAllCategories = true
                } else {
                    discount.appliesToAllCategories = false
                    this.state.selectedSubjectType.forEach(st => {
                        if(st.value !== -1) discount.categories.push(st.value)
                    })
                }
                break;
            case DiscountType.PRODUCT:
                discount.appliesToAllCategories = false

                if (this.state.selectedSubjectType.length === 1 && this.state.selectedSubjectType[0].value === -1) {
                    discount.appliesToAllProducts = true
                } else {
                    discount.appliesToAllProducts = false
                    this.state.selectedSubjectType.forEach(st => {
                        if(st.value !== -1) discount.products.push(st.value)
                    })
                }
                break;
            default:
                discount.appliesToAllProducts = false
                discount.appliesToAllCategories = false
                break;
        }

        const method = this.props.location.discountId ? "put" : "post"
        this.setState({isSubmitInProgress: true});
        axiosCommon({
            method,
            url: `${BASE_URL}/api/discounts`,
            data: discount
        })
            .then(response => {
                this.props.history.goBack();
            })
            .catch(error => {
                this.setState({error, isSubmitInProgress: false});
            });
    };

    handleChange = (event) => {
        const { discount } = this.state;
        discount[event.target.name] = event.target.value;
        this.setState({ discount });
    }

    handleStateChange = (event) => {
        const { discount } = this.state;
        discount.enabled = event.target.value === 'true';
        this.setState({ discount });
    }

    handleShopChange = (event, value) => {
        this.setState({ selectedShopOption: value });
    }

    renderDiscountValueInput = () => {
        switch (this.state.selectedDiscountMethod?.value) {
            case DiscountMethod.PERCENTAGE:
                return <TextValidator
                    label="Kedvezmény mértéke (%)"
                    variant="outlined"
                    fullWidth
                    onChange={this.handleChange}
                    name="value"
                    value={this.state.discount.value || ""}
                    disabled={this.state.isEdit}
                    required
                    validators={['required', 'isNumber','minNumber:1', 'maxNumber:100']}
                    errorMessages={['A mező kitöltése kötelező', 'Csak egész számot lehet megadni', 'A megadott érték nem lehet kisebb 1-nél', 'A megadott érték nem lehet nagyobb 100-nál']}
                />
            case DiscountMethod.DIFFERENCE:
                return <TextValidator
                    label="Kedvezmény mértéke (Ft)"
                    variant="outlined"
                    fullWidth
                    onChange={this.handleChange}
                    name="value"
                    value={this.state.discount.value || ""}
                    disabled={this.state.isEdit}
                    inputProps={{ maxLength: 8 }}
                    required
                    validators={['required', 'isNumber','minNumber:1']}
                    errorMessages={['A mező kitöltése kötelező', 'Csak egész számot lehet megadni', 'A megadott érték nem lehet kisebb 1-nél']}
                />
            case DiscountMethod.ACQUISITION_PRICE:
                return <TextValidator
                    label="Kedvezmény mértéke"
                    variant="outlined"
                    fullWidth
                    disabled
                    name="value"
                    value="Beszerzési ár + Áfa"
                />
            default:
                return undefined;
        }
    }

    renderEdit =() => {
        return <>
            <Toolbar className="mb-16 align-center justify-space-between">
                <Typography variant="h5" id="tableTitle" component="div" >
                    {this.props.location.discountId ? "Kedvezmény szerkesztése" : "Új kedvezmény"}
                </Typography>
                <IconButton onClick={() => this.props.history.goBack()}>
                    <ClearIcon fontSize="large"/>
                </IconButton>
            </Toolbar>

            <ValidatorForm onSubmit={this.onSubmit}>
                <Card title="Általános adatok">
                    <Widget>
                        <div className="flex-1">
                            <TextValidator
                                label="Név"
                                variant="outlined"
                                fullWidth
                                onChange={this.handleChange}
                                name="name"
                                value={this.state.discount.name || ""}
                                required
                                validators={['required']}
                                errorMessages={['A mező kitöltése kötelező']}
                            />
                        </div>
                        <div className="m-8"/>
                        <div className="flex-1">
                            <TextValidator
                                select
                                label="Állapot"
                                variant="outlined"
                                onChange={this.handleStateChange}
                                name="enable"
                                fullWidth
                                value={this.state.discount.enabled === true}
                                InputLabelProps={{ shrink: true }}
                            >
                                <MenuItem key='1' value='true'>Aktív</MenuItem>
                                <MenuItem key='0' value='false'>Szünetel</MenuItem>
                            </TextValidator>
                        </div>
                    </Widget>

                    <Widget>
                        <div className="flex-1">
                            <Autocomplete
                                onChange={this.handleShopChange}
                                name="shopId"
                                fullWidth
                                disableClearable
                                noOptionsText="Nincs ilyen tétel"
                                options={this.state.shopOptions}
                                getOptionLabel={(option) => option === "" ? "" : option.label}
                                getOptionSelected={(option, value) => option.value === value.value}
                                value={this.state.selectedShopOption || ""}
                                renderInput={(params) =>
                                    <TextField {...params} label="Üzlet" variant="outlined" />
                                }
                            />
                        </div>
                        <div className="m-8"/>
                        <div className="flex-1">
                            <TextValidator
                                label="Vonalkód"
                                variant="outlined"
                                fullWidth
                                onChange={this.handleChange}
                                name="barcode"
                                value={this.state.discount.barcode || ""}
                            />
                        </div>
                    </Widget>

                    <TextValidator
                        label="Leírás"
                        multiline
                        fullWidth
                        minRows={3}
                        maxRows={4}
                        variant="outlined"
                        name="description"
                        value={this.state.discount.description || ""}
                        inputProps={{ maxLength: 1024 }}
                        onChange={this.handleChange}
                    />
                </Card>

                <div className="m-8"/>

                <Card title="Kedvezmény beállításai">
                    <Typography style={{marginBottom: 16}}>
                        A kedvezmény beállításai a létrehozás után már nem módosíthatóak.
                    </Typography>
                    <Widget>
                        <div className="flex-1">
                            <Autocomplete
                                multiple
                                onChange={(event, value) => {
                                    const {selectedCustomers} = this.state
                                    let selectedValues = value

                                    if(selectedCustomers.length === 1 && selectedCustomers[0].value === this.state.allOption.value && value.length > 1){
                                        selectedValues = value.filter(v => v.value !== this.state.allOption.value)
                                    } else if(value.includes(this.state.allOption)) {
                                        selectedValues = [this.state.allOption]
                                    }

                                    this.setState({ selectedCustomers: selectedValues })
                                }}
                                name="discountSubject"
                                fullWidth
                                disableClearable
                                disableCloseOnSelect
                                noOptionsText="Nincs ilyen tétel"
                                options={this.state.customerOptions}
                                getOptionLabel={(option) => option === "" ? "" : option.label}
                                getOptionSelected={(option, value) => option.value === value.value}
                                value={this.state.selectedCustomers || []}
                                disabled={this.state.isEdit}
                                renderOption={(option, { selected }) => (
                                    <>
                                        <Checkbox
                                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                            color="primary"
                                        />
                                        {option.label}
                                    </>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" label="Kedvezményre jogosult vásárló" required={this.state.selectedCustomers.length === 0} />
                                )}
                            />
                        </div>
                        <div className="m-8"/>
                        <div className="flex-1">
                            <Autocomplete
                                onChange={(event, value) => {
                                    this.setState({selectedDiscountApplyType: value})
                                }}
                                fullWidth
                                disableClearable
                                noOptionsText="Nincs ilyen tétel"
                                options={this.discountApplyTypeOptions()}
                                getOptionLabel={(option) => option === "" ? "" : option.label}
                                getOptionSelected={(option, value) => option.value === value.value}
                                value={this.state.selectedDiscountApplyType || ""}
                                disabled={this.state.isEdit}
                                renderInput={(params) =>
                                    <TextField {...params} label="Kedvezmény alkalmazása" variant="outlined" />
                                }
                            />
                        </div>
                    </Widget>

                    <Widget>
                        <div className="flex-1">
                            <Autocomplete
                                onChange={this.setDiscountType}
                                fullWidth
                                disableClearable
                                noOptionsText="Nincs ilyen tétel"
                                options={this.discountTypeOptions()}
                                getOptionLabel={(option) => option === "" ? "" : option.label}
                                getOptionSelected={(option, value) => option.value === value.value}
                                value={this.state.selectedDiscountType || this.discountTypeOptions()[0]}
                                disabled={this.state.isEdit || this.state.selectedDiscountMethod?.value === DiscountMethod.ACQUISITION_PRICE}
                                renderInput={(params) =>
                                    <TextField {...params} label="Kedvezmény típusa" variant="outlined" />
                                }
                            />
                        </div>
                        <div className="m-8"/>
                        <div className="flex-1">
                            {this.state.selectedDiscountType?.value === DiscountType.CONSUMER
                                ? undefined
                                : <Autocomplete
                                    multiple
                                    onChange={(event, value) => {
                                        const {selectedSubjectType} = this.state
                                        let selectedValues = value

                                        if(selectedSubjectType.length === 1 && selectedSubjectType[0].value === this.state.allOption.value && value.length > 1){
                                            selectedValues = value.filter(v => v.value !== this.state.allOption.value)
                                        } else if(value.includes(this.state.allOption)) {
                                            selectedValues = [this.state.allOption]
                                        }

                                        this.setState({ selectedSubjectType: selectedValues })
                                    }}
                                    name="discountSubject"
                                    fullWidth
                                    disableClearable
                                    disableCloseOnSelect
                                    noOptionsText="Nincs ilyen tétel"
                                    options={this.state.subjectTypeOptions}
                                    getOptionLabel={(option) => option === "" ? "" : option.label}
                                    getOptionSelected={(option, value) => option.value === value.value}
                                    value={this.state.selectedSubjectType || []}
                                    disabled={this.state.isEdit}
                                    renderOption={(option, { selected }) => (
                                        <>
                                            <Checkbox
                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                                color="primary"
                                            />
                                            {option.label}
                                        </>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Kedvezmény tárgya" required={this.state.selectedSubjectType.length === 0} />
                                    )}
                                />
                            }

                        </div>
                    </Widget>

                    <Widget>
                        <div className="flex-1">
                            <Autocomplete
                                onChange={(event, value) => {
                                    const {discount} = this.state
                                    if(value.value === DiscountMethod.ACQUISITION_PRICE) {
                                        discount.value = 0;
                                        const consumerTypeOption = this.discountTypeOptions().find(o => o.value === DiscountType.CONSUMER);
                                        this.setState({ discount, selectedDiscountMethod: value }, () => {
                                            this.setDiscountType(null, consumerTypeOption);
                                        });
                                    }
                                    else {
                                        discount.value = null;
                                        this.setState({ discount, selectedDiscountMethod: value });
                                    }
                                }}
                                fullWidth
                                disableClearable
                                noOptionsText="Nincs ilyen tétel"
                                options={this.discountMethodOptions()}
                                getOptionLabel={(option) => option === "" ? "" : option.label}
                                getOptionSelected={(option, value) => option.value === value.value}
                                value={this.state.selectedDiscountMethod || ""}
                                disabled={this.state.isEdit}
                                renderInput={(params) =>
                                    <TextField {...params} label="Kedvezmény fajtája" variant="outlined" />
                                }
                            />
                        </div>
                        <div className="m-8"/>
                        <div className="flex-1">
                            {this.renderDiscountValueInput()}
                        </div>
                    </Widget>
                </Card>

                <div className="m-8"/>

                <Card title="Érvényesség">
                    <Widget>
                        <div className="flex-1">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.continuous || false}
                                        onChange={(event) => {
                                            let { continuous } = this.state;
                                            continuous = event.target.checked;
                                            this.setState({ continuous });
                                        }}
                                        color="primary"
                                        name="showInTerminal" />}
                                label="Folyamatos"
                            />
                        </div>
                        <div className="m-8"/>
                        {this.state?.continuous === true
                            ? <div className="flex-1" />
                            : <div className="flex-1" >
                                <StyledDateRangePicker
                                    allowEmpty
                                    fromDate={this.state.fromDate}
                                    toDate={this.state.toDate}
                                    onRangeChange={(fromDate, toDate) => {
                                        this.setState({fromDate, toDate})
                                    }}
                                />
                            </div>
                        }
                    </Widget>
                </Card>

                <div className="m-8"/>

                <Card title="Napi bontás">
                    {Object.entries(this.state.discount.validTimes).map(([day, { start, end }]) => {
                        const isDisabled = this.isDayDisabled(day);
                        return <div key={day} className="flex align-center mb-16">
                            <Checkbox
                                checked={!isDisabled}
                                onChange={(event) => this.setDayEnabled(day, event.target.checked)}
                                color="primary"
                                name={`enabled-${day}`}
                                inputProps={{ style: { height: "100%" } }}
                                style={{ marginRight: 16 }}
                            />
                            <div className="flex" style={{ opacity: isDisabled ? 0.4 : 1 }}>
                                <TextField
                                    label="Nap"
                                    type="text"
                                    InputLabelProps={{ shrink: true }}
                                    value={DayOfWeek[day]}
                                    InputProps={{ readOnly: true }}
                                    disabled={isDisabled}
                                    style={{ marginRight: 32 }}
                                />
                                <TimePicker
                                    ampm={false}
                                    disabled={isDisabled}
                                    label="Érvényesség kezdete"
                                    value={isDisabled || !start ? null : new Date(`2000-01-01T${normalizeTime(start)}`)}
                                    onChange={(date) => this.updateDayValidity(day, "start", date)}
                                    style={{ marginRight: 16, width: 160}}
                                />

                                <TimePicker
                                    ampm={false}
                                    disabled={isDisabled}
                                    label="Érvényesség vége"
                                    value={isDisabled || !end ? null : new Date(`2000-01-01T${normalizeTime(end)}`)}
                                    onChange={(date) => this.updateDayValidity(day, "end", date)}
                                    style={{ marginRight: 16, width: 160}}
                                />
                                <Button
                                    color="primary"
                                    disabled={isDisabled}
                                    onClick={() => this.resetDayValidity(day)}>
                                    Visszaállít
                                </Button>
                            </div>
                        </div>;
                    })}
                </Card>

                <SaveCancelButtons
                    error={this.state.error}
                    isSubmitInProgress={this.state.isSubmitInProgress}
                    onCancel={() => this.props.history.goBack()}
                />
            </ValidatorForm>
        </>
    }

    render() {
        return <section className="main-content">
            <section className="main-content-body">
                <NavHeader changeSidebarToggled={this.props.changeSidebarToggled}/>
                {this.renderEdit()}
            </section>

            <Footer/>
        </section>;
    }
}
